module.exports = __webpack_public_path__ + "static/media/volunteerAvatar-placeholder.5d0a1eaf.svg";